<template>
    <div>
        <div class="card shadow p-0">
            <b-container fluid>
                <div class="card-body p-0">
                    <div class="row p-0">
                        <section id="appointment-table">
                            <div class="appointment-table-header my-2 mb-4">
                                <div class="card-title">
                                     <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a>
                                        <router-link  :to="{ name: 'add-afflitation-from-ama' }" v-if="can">
                                        {{$t('message.addAffiliation')}}

                                        <i class="fas fa-plus-circle edit-icon"></i>
                                    </router-link>
                                </div>
                                <div class="">
                                    <div class="">
                                        <b-input-group size="sm" class="mb-3">
                                            <input type="text" v-model="search" @keyup="searchAffiliation($event)" class="form-control" placeholder="rechercher une affiliation">
                                            <!-- <b-input-group-append>
                                                <b-button size="sm" text="Button" variant="primary" @click="handlerOnFilterButton">Go</b-button>
                                            </b-input-group-append> -->
                                        </b-input-group>
                                       
                                    </div>
                                <div class="overflow-auto p-0 row align-items-center">
                                    <div class="ml-md-1 ml-0 p-0">
                                        <!-- <div v-if="paginationObject.numOfPages > 1" class="pagination-wrapper d-inline-block">
                                            <div class="pagination">
                                                <a
                                                        href="#"
                                                        :class="'prev page-numbers ' + (
                                                paginationObject.currentPageNumber === 1
                                                    ? 'pagination-disabled'
                                                    : ''
                                                )"
                                                        @click="_handlePaginationClick('prev')"
                                                >
                                                    <i aria-hidden="true" class="v-icon fas fa-chevron-left"></i>
                                                </a>
                                                <template v-for="(pageNumber, key) in paginationObject.listOfPageNumber()">
                                                    <template v-if="pageNumber === paginationObject.currentPageNumber">
                                                <span
                                                        :key="key"
                                                        aria-current="page"
                                                        class="page-numbers current"
                                                >
                                                    {{ pageNumber }}
                                                </span>
                                                    </template>
                                                    <template v-else>
                                                        <a
                                                                href="#"
                                                                :key="key"
                                                                class="page-numbers"
                                                                @click="_handlePaginationClick(pageNumber)"
                                                        >
                                                            {{ pageNumber }}
                                                        </a>
                                                    </template>
                                                </template>
                                                <a
                                                        href="#"
                                                        class="next page-numbers"
                                                        :class="'next page-numbers ' + (
                                                paginationObject.currentPageNumber === paginationObject.numOfPages
                                                    ? 'pagination-disabled'
                                                    : ''
                                                )"
                                                        @click="_handlePaginationClick('next')"
                                                >
                                                    <i aria-hidden="true" class="v-icon fas fa-chevron-right"></i>
                                                </a>
                                            </div>
                                        </div> -->
                                    </div>
                                    <div class="form-group m-0">
                                            <select name="type" id="type" v-model="sortCIM" @change="getFilterAffiliations" class="form-control">
                                                <option value="">Tout</option>
                                                <option value="0">Expirés</option>
                                                <option value="7">7</option>
                                                <option value="14">14</option>
                                                <option value="30">30</option>
                                            </select>
                                        </div>
                                </div>
                            </div>

                            </div>
                            <div class="row appointment-table-content p-0">
                                <div class="container-fluid  p-0">
                                    <template>
                                        <div
                                            v-for="(bill, key) in this.mSouscripteurs"
                                            :key="key"
                                            class="row appointment-item">
                                            <div class="col-lg-3">
                                                    <span class="appointment-label">
                                                        {{ $t('message.name') }}
                                                    </span>
                                                <h4 class="appointment-date">{{ bill.nom }}</h4>
                                            </div>
                                            <div class="col-lg-3">
                                                <span class="appointment-label">
                                                        {{ $t('message.email') }}
                                                    </span>
                                                <h4 class="appointment-hour">{{ bill.email }}</h4>
                                            </div>
                                            <div class="col-lg-2 col-6">
                                                <span class="appointment-label">
                                                    {{ $t('message.phoneNumber') }}
                                                </span>
                                                <h4>
                                                    {{ bill.telephone }}
                                                </h4>
                                            </div>
                                            <div class="col-lg-2 col-6">
                                                <span class="appointment-label">
                                                    {{ $t('message.urgence') }}
                                                </span>
                                                <h4>{{ bill.niveau_urgence }}</h4>
                                            </div>
                                            <div class="col-lg-2  col-6">
                                                <span class="appointment-label">
                                                    {{ $t('message.debutAffiliation') }}
                                                </span>
                                                <h4>{{ bill.date_debut }}</h4>
                                            </div>
                                            <div class="col-lg-2  col-6">
                                                <span class="appointment-label">
                                                    {{ $t('message.finAffiliation') }}
                                                </span>
                                                <h4>{{ bill.date_fin }}</h4>
                                            </div>
                                                <div class="col-lg-2  col-12">
                                                <span class="appointment-label">
                                                    {{ $t('message.package') }}
                                                </span>
                                                <h4>{{ bill.description }}</h4>
                                            </div>
                                            <div class="col-lg-2 col-4">
                                                <span class="appointment-label">
                                                    {{ $t('message.status') }}
                                                </span>
                                                <h4 v-if="bill.status_contrat == 'Résilié'" class="text-warning">{{ bill.status_contrat }}</h4>
                                                <h4 v-else-if="bill.status_contrat == 'Expiré'" class="text-danger">{{ bill.status_contrat }}</h4>
                                                <h4 v-else-if="bill.status_contrat == 'Renouvélé'" class="text-primary">{{ bill.status_contrat }}</h4>
                                                <h4 v-else-if="bill.status_contrat == 'Généré'" class="text-warning">{{ bill.status_contrat }}</h4>
                                                <h4 v-else-if="bill.status_contrat == 'Suspendu'" class="text-warning">{{ bill.status_contrat }}</h4>
                                                <h4 v-else class="text-success">{{ bill.status_contrat }}</h4>
                                            </div>
                                            <div class="col-lg-2 col-4">
                                                <span class="appointment-label">
                                                    {{ $t('message.cloture') }}
                                                </span>
                                                <h4 v-if="bill.cloture.ama == '1'" class="text-danger">cloturer</h4>
                                                <h4 v-else class="text-success">ouverte</h4>
                                            </div>
                                            <div class="col-lg-1 col-4">
                                                {{ $t('message.action') }}
                                                <b-button
                                                        variant="primary"
                                                        class="mb-2"
                                                        size="sm"
                                                        @click="viewAffiliation(bill.slug)"
                                                >
                                                {{ $t('message.show') }}
                                                </b-button>
                                                
                                            </div>
                                            <div class="col-lg-1">
                                                {{ $t('message.action') }}
                                                <b-button
                                                        variant="primary"
                                                        class="mb-2"
                                                        size="sm"
                                                        @click="editAffiliation(bill)"
                                                >
                                                {{ $t('message.edit') }}
                                                </b-button>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- <template v-else>
                                        <h4>{{ $t('message.noItemToDisplay') }}</h4>
                                    </template> -->

                                </div>
                            </div>
                            <div>
                                <div class="mt-3" v-if="affiliations.data">
                                    <nav aria-label="Page navigation example">
                                        <ul class="pagination justify-content-end" id="pagination-demo">
                                            <li :class="`page-item ${affiliations.current_page == affiliations.from ? 'disabled' : ''}`"><a class="page-link" href="#" @click="previous(affiliations.current_page)" tabindex="-1" aria-disabled="true"> <span aria-hidden="true">&laquo;</span>
                                                <span class="sr-only">Previous</span></a>
                                            </li>
                                            <li :class="`page-item ${affiliations.current_page == n ? 'active' : ''}`" v-for="n in pages" :key="n" @click="changePage(n)"><a class="page-link" href="#">{{ n }}</a></li>
                                            <!-- <li class="page-item"> -->
                                                <li :class="`page-item ${affiliations.current_page == affiliations.last_page ? 'disabled' : ''}`"><a class="page-link" href="#" @click="next(affiliations.current_page)" tabindex="-1" aria-disabled="true"> <span aria-hidden="true">&raquo;</span>
                                                    <span class="sr-only">Next</span></a>
                                                </li>
                                            <!-- </li> -->
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';
    import { pagination, handlePaginationClick } from "../../helpers/paginations";
    export default {
        name: "Subscribers",

        computed: {
            ...mapGetters(["affiliations",'hasAdminRole',
                'hasGestionnaireRole',
                'hasPraticienRole',
                'hasMedecinControleRole','hasAssistante'
            ]),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante;
            },

            rows: function() {
                return this.affiliations.length;
            },
            pages() {
                let numShown = 10;   // This sets the number of page tabs
                numShown = Math.min(numShown, this.affiliations.last_page);
                let first = this.affiliations.current_page - Math.floor(numShown / 2);
                first = Math.max(first, 1);
                first = Math.min(first, this.affiliations.last_page - numShown + 1);
                return [...Array(numShown)].map((k,i) => i + first);
            },
        },

        data() {
            return {
                search: "",
                mSubscribersFilter:[],
                searchTerm : '',
                mSubscribersColumns: [
                    {
                        field: 'nom',
                        label: this.$i18n.t('message.name'),
                    },
                    {
                        field: 'email',
                        label: this.$i18n.t('message.email'),
                    },
                    {
                        field: 'telephone',
                        label: this.$i18n.t('message.phoneNumber'),
                    },
                    {
                        field: 'nationalite',
                        label: this.$i18n.t('message.nationality'),
                    },
                    {
                        field: 'adresse',
                        label: this.$i18n.t('message.address'),
                        sortable: true
                    },
                ],
                statusOptions:[
                    {
                    value: 1,
                    text: 'Tous'
                    },
                    {
                    value: 'COMPLET',
                    text: 'Complet'
                    },
                    {
                    value: 'A COMPLETER',
                    text: 'A completer'
                    },
                ],
                offset: 0,
                limit: -1,
                sortCIM: '',
                mSouscripteurs: [],
                filterCriteria: '',
                paginationObject: {},
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
            }
        },
        watch:{
            mSouscripteurs: function (newValue, oldValue) {                
                this.paginationObject = pagination(newValue);
            },
            filterCriteria: function (newValue, oldValue) {
                this.handleFilter(newValue);
            },

            affiliations: function() {
                let sArray = [];
                _.forEach(_.orderBy(this.affiliations.data,['created_at'],['desc']), function(affiliate) {
                    let s = {};
                    if((typeof affiliate.patient.user == 'object') && (!_.isNull(affiliate.patient.user) && (!_.isNull(affiliate.souscripteur)))) {
                        let prenom = affiliate.patient.user.prenom ? affiliate.patient.user.prenom : '';
                        let souscripteur_prenom = affiliate.souscripteur ? affiliate.souscripteur.prenom : '';
                        prenom =  prenom.toLowerCase();
                        souscripteur_prenom = souscripteur_prenom != null ? souscripteur_prenom.toLowerCase() : '';
                        let firstLetter = souscripteur_prenom != '' ? souscripteur_prenom.charAt(0).toUpperCase() : '',
                            other_letter = souscripteur_prenom != '' ? souscripteur_prenom.substring(1) : '';
                        s.nom =  (affiliate.patient.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        s.email = affiliate.patient.user.email;
                        s.telephone = affiliate.patient.user.telephone;
                        s.nationalite = affiliate.patient.user.nationalite;
                        s.sexe = affiliate.patient.sexe;
                        s.ville = affiliate.patient.user.ville;
                        s.pays = affiliate.patient.user.pays;
                        s.date = moment(affiliate.patient.user.date_de_naissance).format('DD-MM-YYYY');
                        s.id = affiliate.patient.user.slug;
                        s.date_debut = affiliate.date_debut;
                        s.date_fin = affiliate.date_fin;
                        s.description = affiliate.package.description_fr;
                        s.niveau_urgence = affiliate.niveau_urgence;
                        s.cloture = affiliate.cloture;
                        s.souscripteur = (affiliate.souscripteur.nom).toUpperCase() + " "+ firstLetter + other_letter+" ("+affiliate.souscripteur.email+")";
                        s.status_contrat = affiliate.status_contrat;
                         if(s.nombre_restant === s.nombre_paye){
                            s.status = "COMPLET";
                         }else{
                            s.status = "A COMPLETER";
                         }
                        s.slug = affiliate.slug;
                        s.adresse = affiliate.user.adresse;
                    }
                    sArray.push(s);
                });

                this.mSouscripteurs = sArray;
            },
            // status: function (newValue, oldValue) {

            //         let newCurrentPatientArray = [];
            //          newCurrentPatientArray = this.mSouscripteurs.filter((subElement) => subElement.status === newValue)
            //         this.paginationObject = pagination(newCurrentPatientArray);
            //     if (newValue === 1){
            //        this.paginationObject = pagination(this.mSouscripteurs);
            //     }
            // },
            searchTerm:function (newValue, oldValue) {
                if (this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante){
                    if (newValue.trim().length ==0){
                        this.mSubscribersFilter = [];
                    }else{
                        this.mSubscribersFilter = this.mSubscribers;
                    }
                }
            }
        },
        methods: {
            searchAffiliation(event){
                if(event.target.value.length > 2){
                    this.getAffiliations(1, event.target.value, 5);
                }else if(event.target.value == ""){
                    this.getAffiliations(1, "", 5);
                }
            },
            hasHistory () { return window.history.length > 2 },
            previous(page){
                page--
                this.getAffiliations(page, "", 5);
            },
            next(page){
                page++
                this.getAffiliations(page, "", 5);
            },
            changePage(page){
                this.getAffiliations(page, "", 5);
            },
            onRappelClick(id) {
                let args = {
                    subscriber: id,
                };
                    let successMessage = "Mail de rappel d'ajout de patient a été envoyé au souscripteur";
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') 
                    };                
                this.$store.dispatch('rappelSubscriber', { args, errorMessages, successMessage })
                .then(() => {

                });

            },
            viewAffiliation(slug){
                let user = JSON.parse(localStorage.getItem('user'));
                this.$gtag.set({
                    'user_id': user.id,
                    'role': localStorage.getItem('role'),
                    'email': user.email
                })
                this.$gtag.event("Affichage de l'affilation", {
                    'event_category': "Affiliations",
                    'event_label': "Affichage de l'affilation"
                })

                this.$router.push(  (this.$router.resolve({ name: 'affiliation',  params: { contrat: slug } })).href +  '#generale');

            },
            editAffiliation(bill){
                let patient_label = bill.nom +' ('+bill.email+')',
                    souscripteur_label = bill.souscripteur;
                this.$router.push(  (this.$router.resolve({ name: 'edit-afflitation-from-ama',  params: { contrat: bill.slug, patient_label: patient_label, souscripteur_label: souscripteur_label } })).href +  '#edit');
                // this.$router.push({ name: 'edit-afflitation-from-ama',  params: { contrat: slug } });

            },
            getSubscribers() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getSubscribersCim', { args : args });
            },
            getAffiliations(page = 1, search = "", size = 5) {
                let args = {
                    page: page,
                    search: search,
                    size: size,
                    sortCIM: this.sortCIM,
                };

                this.$store.dispatch('getAffiliations', { args : args });
            },

            //listing des cim, qui expire sur un delais choisis ou qui ont complètement expiré
            getFilterAffiliations(){
                this.getAffiliations();
            },
            mSubscriberClick(params){
                this.$router.push({ name: 'subscriber', params: { subscriber: params.row.slug } });
            },
            _handlePaginationClick(action) {
                this.paginationObject = handlePaginationClick(action, {...this.paginationObject});
            },
            handlerOnFilterButton() {
                event.preventDefault();
                this.handleFilter(this.filterCriteria);
            },

            handleFilter(value) {
                if (value) {
                    const newBills = this.mSouscripteurs.filter(app => {
                        let result = false;

                        if (app.nom) {
                            result = result || app.nom.toLowerCase().includes(value.toLowerCase());
                        }

                        return result;
                    });

                    this.paginationObject = pagination(newBills, 10);
                } else {
                    this.paginationObject = pagination(this.mSouscripteurs, 10);
                }
            },
        },

        mounted() {
            // Fetch subscriber list
            // this.getAffiliations();
            this.getFilterAffiliations();

            let user = JSON.parse(localStorage.getItem('user'));
            this.$gtag.set({
                'user_id': user.id,
                'role': localStorage.getItem('role'),
                'email': user.email
            })
            this.$gtag.event("Listing des affiliations", {
                'event_category': "Affiliations",
                'event_label': "Listing des affiliations"
            })
        }
    }
</script>

<style scoped>

</style>